export type ActivitySearch = {
  taskType: string;
  project: string;
  author: string;
  from: string;
  to: string;
};
export const emptyActivitySearch: ActivitySearch = {
  taskType: "",
  project: "",
  author: "",
  from: "",
  to: "",
};
export function activitySearchFilter(
  search: ActivitySearch,
): Record<string, unknown> {
  const filter: Record<string, unknown> = {};
  if (search.taskType) filter["task_type@eq"] = search.taskType;
  if (search.project) filter["project_id@eq"] = Number(search.project);
  if (search.author) filter["sales_id@eq"] = Number(search.author);
  if (search.from && search.to && search.from > search.to)
    return { ...filter, "activity_category@eq": "__invalid_period__" };
  if (search.from)
    filter["date@gte"] = new Date(`${search.from}T00:00:00`).toISOString();
  if (search.to)
    filter["date@lte"] = new Date(`${search.to}T23:59:59.999`).toISOString();
  return filter;
}
export function matchesActivityFilter(
  event: Record<string, any>,
  filter: Record<string, unknown>,
) {
  return Object.entries(filter).every(([key, value]) => {
    if (value == null) return true;
    if (key.endsWith("_eq_any"))
      return (value as unknown[]).some(
        (v) => String(event[key.slice(0, -7)]) === String(v),
      );
    const match = key.match(/^(.*)_(eq|gte|lte)$/);
    const field = match?.[1] ?? key;
    const operation = match?.[2] ?? "eq";
    if (operation === "gte")
      return event[field] != null && String(event[field]) >= String(value);
    if (operation === "lte")
      return event[field] != null && String(event[field]) <= String(value);
    return (
      event[field] === value ||
      (event[field] != null && String(event[field]) === String(value))
    );
  });
}
